import { render, staticRenderFns } from "./ExportToPlatform.vue?vue&type=template&id=61b56a37&"
import script from "./ExportToPlatform.vue?vue&type=script&lang=js&"
export * from "./ExportToPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports